<svg width="22" height="14" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M8.526 6.64a1.5 1.5 0 0 0 2.115-2.115A2.5 2.5 0 1 1 8.525 6.64zM11 0c5.281 0 10.01 5.89 10.01 5.89.546.613.566 1.625.014 2.25 0 0-4.441 5.86-10.024 5.86C5.415 14 .976 8.14.976 8.14c-.54-.63-.542-1.643.029-2.265C1.005 5.875 5.716 0 11 0zm0 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    fill-rule="evenodd"
    fill="#82619e"
  />
</svg>
